import { useOktaAuth } from '@okta/okta-react';
import useAssignmentForm, {
	type PrincipalFormValues,
	toPrincipalPayload,
} from '@/components/AssignmentForm/useAssignmentForm';
import Breadcrumbs from '@/components/Breadcrumbs';
import { AUTH_SERVICES_BASE_URL, PRINCIPALS_API_URL } from '@constants/url';
import useToken from '@hooks/useToken';
import useTopbar from '@hooks/useTopbar';
import { postFetchWithRenewal } from '@utils/post-fetch-with-renewal';

/**
 * The assignment form pointed at the principals endpoint. Everything about how
 * the fields behave lives in useAssignmentForm; this only says where a valid
 * form goes.
 */
const useAddAssignmentPage = () => {
	const token = useToken();
	const { oktaAuth } = useOktaAuth();

	useTopbar(<Breadcrumbs />);

	return useAssignmentForm({
		successMessage: 'App assignment submitted',
		submit: async (values: PrincipalFormValues) => {
			if (!AUTH_SERVICES_BASE_URL) {
				throw new Error('Auth services URL is not configured');
			}

			return await postFetchWithRenewal<unknown>(
				oktaAuth,
				token,
				PRINCIPALS_API_URL,
				// The form has no operation type field — it only ever assigns.
				toPrincipalPayload({ ...values, operationType: 'assign' })
			);
		},
	});
};

export default useAddAssignmentPage;
